import SchoolsNavMenu from './SchoolsNavMenu';
export default SchoolsNavMenu;
